import React from 'react';
import { inject, observer } from 'mobx-react';
import { observable, action, computed } from 'mobx';
import { SelectInput } from './Form';
import { getDisplayDate } from '../libs/date';

@inject('stationStore')
@observer
class ImageGrid extends React.Component {

  sizeOptions = [
    { size: 9, containerStyle: { gridTemplateColumns: 'repeat(3, 33.33%)' }, itemStyle: { height: '200px' } },
    { size: 12, containerStyle: { gridTemplateColumns: 'repeat(4, 25%)' }, itemStyle: { height: '200px' } },
    { size: 16, containerStyle: { gridTemplateColumns: 'repeat(4, 25%)' }, itemStyle: { height: '150px' } },
  ]

  @observable pagination = {
    page: 0,
    size: 12,
  };
  @observable selectedImage = null;

  @computed get totalPages() {
    return Math.ceil(this.props.images.length / this.pagination.size);
  }

  render() {
    const { images, baseUrl, stationStore } = this.props;
    const
      gridSize = this.sizeOptions.find(item => item.size === this.pagination.size),
      start = this.pagination.page * this.pagination.size,
      end = start + this.pagination.size;

    return (
      <div>
        {!!this.selectedImage ?
          <div className='imageContainer image-slider' style={{ height: '600px' }}>
            <div className='image-slider-image'>
              <img src={`${baseUrl}/${this.selectedImage.source}`} alt='not-found' />
            </div>
            <div className='imageExpand' style={{ display: 'block' }}>
              <span className='fa fa-close' onClick={() => this.selectedImage = null} />
            </div>
          </div> :
          <div className='grid-container' style={{ width: '100%', ...gridSize.containerStyle }}>
            {images.slice(start, end).map(item => (
              <div className='imageContainer grid-item' style={gridSize.itemStyle}>
                <div style={{
                  height: '100%',
                  width: '100%',
                  backgroundImage: `url(${baseUrl}/${item.source})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                }} />
                <div className='imageExpand'>
                  <span className='fa fa-expand' onClick={() => this.selectedImage = item} />
                </div>
                <div className='grid-item-label' style={{ top: 4, bottom: 'unset' }}>
                  <span>{stationStore.findById(item.station_id, 'name')}</span>
                </div>
                <div className='grid-item-label'>
                  <span>{getDisplayDate(item.date_taken)}</span>
                  <span>{item.album_code}</span>
                </div>
              </div>
            ))}
          </div>}
        <div className='inline-grid v-center' style={{ gap: 0, marginTop: '8px' }}>
          <div className='inline-grid v-center'>
            <label>Grid Size</label>
            <SelectInput id='pagination' label="" defaultValue={12} fields={{ label: 'size', value: 'size' }} value={this.pagination.size} options={this.sizeOptions} sortOptions={(a, b) => a.size - b.size} onChange={e => { this.pagination.size = e.target.value; this.pagination.page = 0; }} small />
          </div>
          <span className='flex-grow' />
          <div className='v-center'>
            <span className='button button-inactive' onClick={() => this.pagination.page = 0} ><i className="fa fa-angle-double-left" /></span>
            <span className='button button-inactive' onClick={() => this.pagination.page != 0 && this.pagination.page--} ><i className="fa fa-angle-left" /></span>
            <b style={{ margin: '0 8px' }}>{this.pagination.page + 1} of {this.totalPages}</b>
            <span className='button button-inactive' onClick={() => this.pagination.page != this.totalPages - 1 && this.pagination.page++} ><i className="fa fa-angle-right" /></span>
            <span className='button button-inactive' onClick={() => this.pagination.page = this.totalPages - 1} ><i className="fa fa-angle-double-right" /></span>
          </div>
        </div>
      </div>
    );
  }
}

export default ImageGrid;


// WEBPACK FOOTER //
// ./src/components/ImageGrid.js